import dayjs, { Dayjs } from "dayjs";

export const buildDatePayload = (
    fromDate: Dayjs,
    toDate: Dayjs,
    format = "YYYY-MM-DD"
) => {
    return {
        fromDate: fromDate.format(format),
        toDate: toDate.format(format),
    };
};